module.exports = __webpack_public_path__ + "img/Weapon_116.9e7e6b81.png";